import React from "react";
import Image from "../../../images/user.svg";

const Schedule = (props) => {
  return (
    <div className="card">
      <h3>School Schedule</h3>
      <div className="card-body">
        <div className="update-images-div">
          {props.data?.uncommonNewData?.imageHighSchoolOne &&
            props.data?.uncommonNewData?.imageHighSchoolOne !== "None" && (
              <div className="img-box">
                <img
                  src={props.data?.uncommonNewData?.imageHighSchoolOne}
                  alt={Image}
                />
              </div>
            )}

          {props.data?.uncommonNewData?.imageHighSchoolTwo &&
            props.data?.uncommonNewData?.imageHighSchoolTwo !== "None" && (
              <div className="img-box">
                <img
                  src={props.data?.uncommonNewData?.imageHighSchoolTwo}
                  alt={Image}
                />
              </div>
            )}
          {props.data?.uncommonNewData?.imageHighSchoolThree &&
            props.data?.uncommonNewData?.imageHighSchoolThree !== "None" && (
              <div className="img-box">
                <img
                  src={props.data?.uncommonNewData?.imageHighSchoolThree}
                  alt={Image}
                />
              </div>
            )}
          {props.data?.uncommonNewData?.imageHighSchoolFour &&
            props.data?.uncommonNewData?.imageHighSchoolFour !== "None" && (
              <div className="img-box">
                <img
                  src={props.data?.uncommonNewData?.imageHighSchoolFour}
                  alt={Image}
                />
              </div>
            )}
          {props.data?.uncommonNewData?.imageHighSchoolFive &&
            props.data?.uncommonNewData?.imageHighSchoolFive !== "None" && (
              <div className="img-box">
                <img
                  src={props.data?.uncommonNewData?.imageHighSchoolFive}
                  alt={Image}
                />
              </div>
            )}
        </div>
      </div>
    </div>
  );
};

export default Schedule;
